import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

type DemandChangeThreshold = number | null;

export default class MiDemandService extends Service {
  @tracked demandChangeThreshold: DemandChangeThreshold = null;

  // Will be called when leaving the route/switching hotels

  clearValues(): void {
    this.demandChangeThreshold = null;
  }

  setDemandChangeThreshold(demandChangeThreshold: DemandChangeThreshold): void {
    this.demandChangeThreshold = demandChangeThreshold;
  }
}

declare module '@ember/service' {
  interface Registry {
    'mi-demand': MiDemandService;
  }
}
